import React from 'react'


const Header = () => {
    return (
        <section id="heading" className="p-d-flex p-justify-center">
            <h1>Employee Directory</h1>
        </section>
    )
}

export default Header
